import type { Client } from '@urql/core'
import { graphql } from 'app/generated/gql'

import type { AdPlatformMapping as AdPlatformMappingType, AdPlatformMappingListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const AD_PLATFORM_MAPPING_FIELDS = `createdDate id medium orgId platform source updatedDate version workspaceId`

const LIST_QUERY = graphql(`
  query AdPlatformMappings($search: String, $pagination: PaginationInput, $sort: SortInput) {
    adPlatformMappings(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        createdDate
        id
        medium
        orgId
        platform
        source
        updatedDate
        version
        workspaceId
      }
      total
      page
    }
  }
`)

const CREATE_MUTATION = graphql(`
  mutation CreateAdPlatformMappingStore($input: CreateAdPlatformMappingInput!) {
    createAdPlatformMapping(input: $input) {
      createdDate
      id
      medium
      orgId
      platform
      source
      updatedDate
      version
      workspaceId
    }
  }
`)

const UPDATE_MUTATION = graphql(`
  mutation UpdateAdPlatformMappingStore($id: ID!, $input: UpdateAdPlatformMappingInput!) {
    updateAdPlatformMapping(id: $id, input: $input) {
      createdDate
      id
      medium
      orgId
      platform
      source
      updatedDate
      version
      workspaceId
    }
  }
`)

const DELETE_MUTATION = graphql(`
  mutation DeleteAdPlatformMapping($id: ID!) {
    deleteAdPlatformMapping(id: $id)
  }
`)

export class AdPlatformMappingStore extends EntityStore<
  AdPlatformMappingType,
  AdPlatformMappingListResult,
  typeof CREATE_MUTATION,
  typeof UPDATE_MUTATION
> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: undefined,
      createMutation: CREATE_MUTATION,
      updateMutation: UPDATE_MUTATION,
      deleteMutation: DELETE_MUTATION,
      typename: `AdPlatformMapping`,
      extractList: (data: any) => data.adPlatformMappings,
      extractMutated: (data: any) => data.updateAdPlatformMapping ?? data.createAdPlatformMapping,
    })
  }
}
